var _linearGradient, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyicon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SK7n3APNjcs6R_Z9A0y6Ca",
    x1: 9.858,
    x2: 38.142,
    y1: 9.858,
    y2: 38.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f44f5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    stopColor: "#ee3d4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e52030"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SK7n3APNjcs6R_Z9A0y6Ca)",
    d: "M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.765,21H18v5h5.91c-1.466,2.417-3.225,3-4.91,3c-3.314,0-5-2.967-5-5c0-1.939,2.06-5,5-5 c1.5,0,2.868,0.554,3.92,1.465l3.151-3.106C24.471,15.894,22.728,14,19,14c-4.971,0-10,4.173-10,10c0,4.971,3.995,10,10,10 c6.225,0,10-5.029,10-10C29,22.834,28.765,21,28.765,21z",
    opacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.265,21.5H18.5v4h5.91c-0.971,2.627-3.082,4-5.41,4c-3.314,0-5.5-2.826-5.5-5.5 c0-2.627,2.373-5.5,5.5-5.5c1.5,0,2.868,0.554,3.92,1.465l2.651-2.606C23.971,15.894,22.034,14.5,19,14.5 c-4.971,0-9.5,4.101-9.5,9.5c0,4.971,4.012,9.5,9.5,9.5c5.598,0,9.5-4.529,9.5-9.5C28.5,22.834,28.265,21.5,28.265,21.5z",
    opacity: 0.07
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.815,22.2l-0.05-0.2H19v3h5.91c-0.477,2.837-2.938,5-5.91,5c-3.314,0-6-2.686-6-6s2.686-6,6-6 c1.5,0,2.868,0.554,3.92,1.465l2.151-2.106C23.471,15.894,21.34,15,19,15c-4.971,0-9,4.029-9,9s4.029,9,9,9s9-4.029,9-9 C28,23.383,27.934,22.782,27.815,22.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5,21H37v-1.5c0-0.828-0.672-1.5-1.5-1.5h-1c-0.828,0-1.5,0.672-1.5,1.5V21h-1.5 c-0.828,0-1.5,0.672-1.5,1.5v1c0,0.828,0.672,1.5,1.5,1.5H33v1.5c0,0.828,0.672,1.5,1.5,1.5h1c0.828,0,1.5-0.672,1.5-1.5V25h1.5 c0.828,0,1.5-0.672,1.5-1.5v-1C40,21.672,39.328,21,38.5,21z",
    opacity: 0.05
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5,21.5h-2v-2c0-0.552-0.448-1-1-1h-1c-0.552,0-1,0.448-1,1v2h-2c-0.552,0-1,0.448-1,1v1 c0,0.552,0.448,1,1,1h2v2c0,0.552,0.448,1,1,1h1c0.552,0,1-0.448,1-1v-2h2c0.552,0,1-0.448,1-1v-1 C39.5,21.948,39.052,21.5,38.5,21.5z",
    opacity: 0.07
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M34.5,19h1c0.276,0,0.5,0.224,0.5,0.5v7c0,0.276-0.224,0.5-0.5,0.5h-1c-0.276,0-0.5-0.224-0.5-0.5v-7 C34,19.224,34.224,19,34.5,19z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.5,22h7c0.276,0,0.5,0.224,0.5,0.5v1c0,0.276-0.224,0.5-0.5,0.5h-7c-0.276,0-0.5-0.224-0.5-0.5v-1 C31,22.224,31.224,22,31.5,22z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyicon2);
export default __webpack_public_path__ + "static/media/myicon2.8d367a51bd75c83218947606fcf8a3dd.svg";
export { ForwardRef as ReactComponent };